import DateUtil from "../../util/DateUtil";
import dateViewTemplate from "./DateViewTemplate";

const DateDirective = angular
    .module("DateDirective", [])
    .directive("pwDate", dateDirective)
    .directive("pwDateValidator", dateValidator);

/**
 * @see http://stackoverflow.com/a/19228302/4454238
 */
function dateDirective() {
    return {
        restrict: "E",
        template: dateViewTemplate,
        priority: 1000,
        scope: {
            name: "@dateName",
            id: "@dateId",
            class: "@dateClass",
            model: "=dateModel",
            isRequired: "&",
            isDisabled: "&",
            minDate: "=",
            allowFutureDate: "="
        },
        bindToController: true,
        controllerAs: "ctrl",
        controller: function () {
            if (typeof this.class == "undefined") {
                this.class = "form-control";
            }
        }
    };
}

function dateValidator() {
    return {
        restrict: "A",
        require: "ngModel",
        scope: {
            minDate: "=",
            allowFutureDate: "="
        },
        link: function (scope, elem, attr, ctrl) {
            var newValue = null;

            elem.bind("blur", function () {
                scope.$apply(function () {
                    newValue = elem.val();
                });
            });

            ctrl.$validators.valid = function (value) {
                var valid = true;
                var m = DateUtil.formatExistingDate("MMDDYYYY", value);

                if (newValue !== null && value != newValue) {
                    value = newValue;
                }

                if (ctrl.$isEmpty(value)) {
                    // consider empty models to be valid
                    return true;
                }

                // Check the validity
                if (value && value.length > 0) {
                    //&& value.length != 8  ) {
                    valid = m.isValid();
                } else if (!m.isValid()) {
                    var parsingFlags = m.toDate().parsingFlags();

                    if (parsingFlags.charsLeftOver > 0) {
                        // If there are non-date characters left over, it is invalid
                        valid = false;
                    } else if (!parsingFlags.empty && !parsingFlags.nullInput) {
                        // If the date is empty or null, it is still valid
                        valid = false;
                    }
                }

                return valid;
            };

            // Only apply the minYear validator if a minimum was defined
            if (scope.minDate) {
                ctrl.$validators.minYear = function (value) {
                    var valid = true;

                    // Pass through until we get a complete date
                    if (value && value.length === 8) {
                        // The date is valid if it is on or after the minimum date
                        valid = !DateUtil.isBefore(
                            DateUtil.getDateFormatted("MMDDYYYY"),
                            scope.minDate
                        );
                    }

                    return valid;
                };
            }

            if (scope.allowFutureDate === false) {
                ctrl.$validators.futureDateNotAllowed = function (value) {
                    var valid = true;

                    // Pass through until we get a complete date
                    if (value && value.length === 8) {
                        // The date is valid if it is not after today
                        valid = !DateUtil.isAfter(
                            DateUtil.getDateFormatted("MMDDYYYY"),
                            DateUtil.getDate()
                        );
                    }

                    return valid;
                };
            }
        }
    };
}

export default DateDirective;
